import { useDispatch } from "react-redux";
import { curatorBackupActions } from "../redux/slicers/admin/curatorBackupSlicer";
import { curatorExclusivePropsActions } from "../redux/slicers/admin/curatorExclusivePropSlicer";
import { curatorLightActions } from "../redux/slicers/admin/curatorLightSlicer";
import { curatorLoaderActions } from "../redux/slicers/admin/curatorLoaderSlicer";
import { curatorLoadingProgressBarActions } from "../redux/slicers/admin/curatorLoadingProgressBarSlicer";
import { curatorMetadataActions } from "../redux/slicers/admin/curatorMetadataSlicer";
import { curatorMissingDataActions } from "../redux/slicers/admin/curatorMissingDataSlicer";
import { curatorProjectArchiveActions } from "../redux/slicers/admin/curatorProjectArchiveSlicer";
import { curatorActions, setCuratorLoader, setSidebarSection } from "../redux/slicers/admin/curatorSlicer";
import { curatorStyleActions } from "../redux/slicers/admin/curatorStylesSlicer";
import { curatorTextureUploadFailedDialogActions } from "../redux/slicers/admin/curatorTextureUploadFailedDialogSlicer";
import { curatorUnityObjectActions } from "../redux/slicers/admin/curatorUnityObjectSlicer";
import { paginatedRenderPreviewsActions } from "../redux/slicers/admin/paginatedRenderPreviewsSlicer";
import { shortcutsModuleActions } from "../redux/slicers/admin/shortcutsModuleSlicer";
import { cameraAngleActions } from "../redux/slicers/camera/cameraAngleSlicer";
import { setGlobalSafeCameraFlag } from "../redux/slicers/camera/cameraSettings";
import { useInfoDialogaActions } from "./useInfoDialogaActions";

export const useResetCuratorState = () => {
  const dispatch = useDispatch();
  const { clearInfoDialog } = useInfoDialogaActions();

  const resetCuratorState = () => {
    // reset curator state
    clearInfoDialog();
    dispatch(setSidebarSection(null))
    dispatch(curatorProjectArchiveActions.resetState());
    dispatch(curatorLoadingProgressBarActions.resetState());
    dispatch(curatorLightActions.resetState());
    dispatch(curatorMetadataActions.resetState());
    dispatch(curatorActions.resetState());
    dispatch(curatorStyleActions.resetState());
    dispatch(curatorUnityObjectActions.resetState());
    dispatch(paginatedRenderPreviewsActions.resetState());
    dispatch(curatorExclusivePropsActions.resetState())
    dispatch(cameraAngleActions.resetState())
    dispatch(curatorMissingDataActions.resetState())
    dispatch(shortcutsModuleActions.resetState())
    dispatch(curatorLoaderActions.resetState())
    dispatch(curatorBackupActions.resetState())
    dispatch(setGlobalSafeCameraFlag(false));
    dispatch(curatorTextureUploadFailedDialogActions.resetState())
    dispatch(setCuratorLoader(true));
  }

  return {
    resetCuratorState,
  }
}